import {connect} from "react-redux";
import {postSession} from "../middleware/loginActions";
import LoginForm from "../components/LoginForm";
import {State} from "../reducers/index";
import {GenericThunkDispatch} from "../types/Types";
import {createLoadingSelector} from "../utils/selectors";
import {POST_SESSION_BASE, updateRecaptchaId} from "../actions/login";
import SigninForm from "../components/SigninForm";

const loadingSelector = createLoadingSelector([
  POST_SESSION_BASE
])

const mapStateToProps = (state: State) => ({
  message: state.login.message,
  showRecaptcha: state.login.showRecaptcha,
  loading: loadingSelector(state),
  isSubmitted: state.login.isSubmitted
});

const mapDispatchToProps = (dispatch: GenericThunkDispatch) => {
  return {
    login: (username: string, password: string) => {
      dispatch(postSession(username, password))
    },
    updateRecaptchaId: (id: number) => {
      dispatch(updateRecaptchaId(id));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(SigninForm);
